export class MediaTypeUtil {

  public static readonly EXCEL_TYPES: string[] = [
    'application/vnd.ms-excel',
    'application/x-msexcel',
    'application/x-ms-excel',
    'application/x-excel',
    'application/x-dos_ms_excel',
    'application/xls',
    'application/x-xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
    'application/msexcel',
  ];
  public static readonly CSV_TYPES: string[] = ['application/csv', 'text/csv'];
  public static readonly PDF_TYPES: string[] = ['application/pdf', 'application/x-pdf'];
  public static readonly POWER_POINT_TYPES: string[] = [
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation'
  ];

  public static readonly DEFAULT_UPLOAD_TYPES: string[] = [
    ...MediaTypeUtil.EXCEL_TYPES,
    ...MediaTypeUtil.CSV_TYPES,
    ...MediaTypeUtil.PDF_TYPES,
    ...MediaTypeUtil.POWER_POINT_TYPES,
  ];

}
